import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Grid
} from '@mui/material';
import CustomerLayout from '../CustomerLayout'; // ✅ Adjust path if needed

const Recommendations = () => {
  return (
    <CustomerLayout>
      <div style={{ padding: '20px' }}>
        <Typography variant="h4" gutterBottom>Recommendations</Typography>

        <Grid container spacing={3} justifyContent="center">
          {/* Contactless Delivery Recommendation */}
          <Grid item xs={12} sm={6} md={4}>
            <Card elevation={3}>
              <CardContent>
                <Typography variant="h5" gutterBottom>Contactless Delivery</Typography>
                <Typography variant="body1" paragraph>
                  Opt for contactless delivery for added convenience and safety. Your parcels are left securely at your doorstep without needing to meet the courier. Simple, safe, and efficient.
                </Typography>
                <Button variant="contained" color="primary">Learn More</Button>
              </CardContent>
            </Card>
          </Grid>

          {/* Delivery Tracking Recommendation */}
          <Grid item xs={12} sm={6} md={4}>
            <Card elevation={3}>
              <CardContent>
                <Typography variant="h5" gutterBottom>Delivery Tracking</Typography>
                <Typography variant="body1" paragraph>
                  Stay informed with real-time updates from pickup to drop-off. With delivery tracking, you'll know exactly where your parcel is and when it will arrive.
                </Typography>
                <Button variant="contained" color="primary">Track Your Parcel</Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    </CustomerLayout>
  );
};

export default Recommendations;
